// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.GetIdVerificationInfoWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetIdVerificationInfoWebApiResponseDto } from '../..';

export const GetIdVerificationInfoWebApiHandler_getIdVerificationInfo_Path = '/api/web/v1/getIdVerificationInfo';

/**
 * get landlord id verification info
 */
export const GetIdVerificationInfoWebApiHandler_getIdVerificationInfo = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetIdVerificationInfoWebApiResponseDto>(
    {
      endpoint: GetIdVerificationInfoWebApiHandler_getIdVerificationInfo_Path,
      method: 'GET',
      contextPath: '/rent-payment',
    },
    client,
  );
};
